module.exports = __webpack_public_path__ + "static/media/30_A.dd7f05e6.png";